import { Injectable } from '@angular/core';
import { FlightWatchModelResponse } from 'src/app/models/flight-watch';
import { SwimFilter } from 'src/app/models/filter';
import { AicraftHelper } from 'src/utils/aircraft';

@Injectable({
    providedIn: 'root'
})
export class FlightWatchFilterService {
    constructor() {}

    /**
     * Filters flight watch data based on the provided filters
     * @param filters - Filter configuration
     * @param records - Records to filter
     * @returns Filtered records
     */
    filterData(
        filters: SwimFilter,
        records: FlightWatchModelResponse[]
    ): FlightWatchModelResponse[] {
        if (!records || records.length === 0) {
            return [];
        }

        let filteredRecords = [...records];

        // Filter by aircraft type
        if (filters.filteredTypes && filters.filteredTypes.length > 0) {
            filteredRecords = this.filterByAircraftType(filteredRecords, filters.filteredTypes);
        }

        // Filter commercial aircraft visibility
        if (filters.isCommercialAircraftVisible === false) {
            filteredRecords = this.filterByCommercialAircraft(filteredRecords);
        }

        // Filter by text
        const filterText = filters.filterText?.toLowerCase();
        if (filterText && filterText.trim()) {
            filteredRecords = this.filterByText(filteredRecords, filterText);
        }

        return filteredRecords;
    }

    /**
     * Filters records by aircraft type codes
     */
    private filterByAircraftType(
        records: FlightWatchModelResponse[],
        types: string[]
    ): FlightWatchModelResponse[] {
        return records.filter((fw) => types.includes(fw.aircraftTypeCode));
    }

    /**
     * Filters out commercial aircraft if visibility is disabled
     */
    private filterByCommercialAircraft(
        records: FlightWatchModelResponse[]
    ): FlightWatchModelResponse[] {
        return records.filter((flightWatch) => {
            const isCommercial = AicraftHelper.isCommercialAircraft(
                flightWatch.atcFlightNumber,
                flightWatch.flightDepartment ?? flightWatch.faaRegisteredOwner,
                flightWatch.aircraftTypeCode
            );

            // Show if not commercial, or if no department/owner info available
            if (!isCommercial || (!flightWatch.flightDepartment && !flightWatch.faaRegisteredOwner)) {
                return true;
            }

            return false;
        });
    }

    /**
     * Filters records by text search (tail number, department, cities)
     */
    private filterByText(
        records: FlightWatchModelResponse[],
        filterText: string
    ): FlightWatchModelResponse[] {
        return records.filter(
            (fw) =>
                fw.tailNumber?.toLowerCase().includes(filterText) ||
                fw.flightDepartment?.toLowerCase().includes(filterText) ||
                fw.departureCity?.toLowerCase().includes(filterText) ||
                fw.arrivalCity?.toLowerCase().includes(filterText)
        );
    }
}

